<script>
	const Q = require('q');
	const page = require('page');
	const model = require('model/model');
	const routeContext = require('core/routeContext');
	const utilities = require('utilities');

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const getLibrarySuggestions = studentLibraryUtilities.getLibrarySuggestions;
	const getReadingList = studentLibraryUtilities.getReadingList;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_PROMO = analyticsUtilities.events.SL_PROMO;
	const SL_PROMO_CLICK = analyticsUtilities.events.SL_PROMO_CLICK;
	const SL_ARTICLE_VIEW = analyticsUtilities.events.SL_ARTICLE_VIEW;
	const SL_LIBRARY_OPEN = analyticsUtilities.events.SL_LIBRARY_OPEN;

	module.exports = {
		components: {
			'library-product-card': require('components/library-product-card.vue').default,
			'load-mask': require('components/load-mask.vue').default
		},
		modelData: ['activeClass', 'libraryProducts'],
		props: {
			product: {
				required: true
			},
			grade: {
				required: true
			}
		},
		data() {
			return {
				hits: [],
				loading: false
			};
		},
		methods: {
			getLibraryProduct(id) {
				let libraryProducts = this.libraryProducts;
				let result = null;
				let parse = utilities.parseProductUUIDAndVersion(id);
				let uuid = null;

				if (parse && parse.uuid) {
					uuid = parse.uuid;
				}

				if (uuid && libraryProducts && libraryProducts[uuid]) {
					result = libraryProducts[uuid];
				}
				return result;
			},
			firePromoClick(id, loc) {
				let aid = routeContext.getParam('aid') || undefined;
				let cc = this.activeClass ? this.activeClass.cc : undefined;
				let pid = id || undefined;

				fireEvent(SL_PROMO_CLICK, {
					aid,
					cc,
					pid,
					loc
				});
			},
			onSuggestionClick(e, id, articleIndex, level) {
				let cc = this.activeClass ? this.activeClass.cc : undefined;
				let pid = id || undefined;
				let libraryProduct = this.getLibraryProduct(id);
				let loc = 'workspace_promo';

				if (id) {
					this.firePromoClick(id, 'article');
					fireEvent(SL_ARTICLE_VIEW, {
						cc,
						pid,
						bookmark: libraryProduct ? libraryProduct.readNext : false,
						loc,
						articleIndex,
						level
					});
					page('/student-library');
					model.set({
						libraryView: 'content',
						productId: id
					});
				}
			},
			onLibraryClick() {
				let cc = this.activeClass ? this.activeClass.cc : undefined;
				let loc = 'WORKSPACE_PROMO';
				this.firePromoClick(undefined, 'sl');
				fireEvent(SL_LIBRARY_OPEN, {
					cc,
					loc
				});
			},
			onBookmarkClick(e, id) {
				this.firePromoClick(id, 'bookmark');
			}
		},
		mounted() {
			this.$watch(
				function () {
					return [this.product, this.grade];
				},
				() => {
					let aid = routeContext.getParam('aid') || undefined;
					let cc = this.activeClass ? this.activeClass.cc : null;
					let pid = this.product.uuid;
					let productType = this.product.productType;
					let grade = this.grade;

					if (pid && productType && grade) {
						this.loading = true;
						let pt = this.product.productType;
						let g = this.grade;
						let exclusion;

						if (productType === 'P') {
							pid = this.product.articleList[0].uuid;

							exclusion = this.product.articleList[1].uuid;
						}

						Q.all([getLibrarySuggestions(pid, pt, g, exclusion), getReadingList()]).spread(hits => {
							this.loading = false;
							this.hits = hits;
							if (hits && hits.length) {
								fireEvent(SL_PROMO, {
									pid,
									aid,
									cc
								});
							}
						});
					}
				},
				{
					immediate: true
				}
			);
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';

	.student-library-suggestions {
		.suggestion-container {
			position: relative;
			min-height: 10rem;
		}

		.find-more {
			margin-bottom: 2rem;
		}

		.library-product-card {
			.product-title {
				font-size: 1.25rem;
			}

			// &.horizontal .product-image .article-image .article-featured-image-container {
			// 	width: 5rem;
			// 	height: 5rem;
			// }
		}
	}

	// @media only screen and (min-width: $bp-width-med) {

	// }
</style>
<template>
	<div class="student-library-suggestions">
		<div class="find-more">
			Find more passages like this one in your
			<a
				href="/student-library"
				@click="onLibraryClick"
				>Library</a
			>. Read these passages next:
		</div>
		<div class="suggestion-container">
			<load-mask
				v-if="loading"
				text="Loading passages you might enjoy..."></load-mask>
			<library-product-card
				v-for="(hit, index) in hits"
				:key="hit.id"
				:id="hit.id"
				:img="hit.img_highres2"
				:img-alt="hit.imgAlt"
				:title="hit.title"
				:topics="hit.libraryTopics"
				:horizontal="true"
				:versioned="true"
				:link="false"
				:on-product-click="onSuggestionClick"
				:on-bookmark-click="onBookmarkClick"
				:location="'workspace_promo'"
				:article-index="index"
				:level="((hit.canonicalGrade && [hit.canonicalGrade]) || hit.grades) | getGradeRangeString">
			</library-product-card>
		</div>
	</div>
</template>
